import { Integration } from 'signup-constants/Integration';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { setError } from '../store/error/action-creators';
import { integratedAppRedirect, setIntegratedAppAuthRedirectUrl } from '../store/integrations/action-creators';
import { getIntegratedAppRedirectParams } from './useIntegratedAppRedirect';
const INTEGRATED_APP_ERROR_CONFIG = {
  [Integration.Wordpress]: {
    errorKey: ErrorKey.WordpressAuthorizationError,
    errorMessage: 'Wordpress Authorization failed.',
    logger: Logger.getLogger('wordpressAuthorization')
  },
  [Integration.ShopifyEmbedded]: {
    errorKey: ErrorKey.IntegratedAppAuthorizationError,
    errorMessage: 'Shopify Authorization failed.',
    logger: Logger.getLogger('shopifyAuthorization')
  },
  [Integration.GoogleWorkspaceApp]: {
    errorKey: ErrorKey.IntegratedAppAuthorizationError,
    errorMessage: 'Google Workspace App Authorization failed.',
    logger: Logger.getLogger('googleWorkspaceAppAuthorization')
  }
};
export const handleIntegratedAppAuthorizationError = integration => (error = {
  message: ''
}, dispatch) => {
  const {
    errorKey,
    errorMessage,
    logger
  } = INTEGRATED_APP_ERROR_CONFIG[integration];
  logger.error(errorMessage, {
    extra: getSentryExtra(error)
  });
  dispatch(setError(errorKey, error));
};
export const handleGoogleWorkspaceAppAuthorizationResponse = (response, dispatch, getState) => {
  const state = getState();
  const params = getIntegratedAppRedirectParams(state);
  dispatch(setIntegratedAppAuthRedirectUrl(response.redirectUrl));
  dispatch(integratedAppRedirect(Object.assign({}, params, {
    redirectUrl: response.redirectUrl
  })));
};